<template>
  <div>
    <modal
      name="userInformations"
      title="User Information"
      class="custom-modal"
      height="auto"
      width="80%"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <validation-observer ref="observer">
            <form class="add-users">
              <div class="form-wrapper mb-base">
                <validation-provider rules="required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="Full Name"
                    :error="errors[0]"
                    type="text"
                    v-model="details.full_name"
                  />
                </validation-provider>
                <validation-provider rules="email|required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="Email Address"
                    :error="errors[0]"
                    type="email"
                    v-model="details.email"
                  />
                </validation-provider>
                <div class="datepicker-wrapper">
                  <DatePicker
                    label="Age-Year"
                    :error="showError"
                    :input="ageYear"
                    labelFor="dob"
                  />
                </div>
                <validation-provider rules="required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="Address"
                    :error="errors[0]"
                    type="text"
                    v-model="details.address"
                  />
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="City"
                    :error="errors[0]"
                    type="text"
                    v-model="details.city"
                  />
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }">
                  <Radio
                    class="mb-base"
                    outerLabel="Gender"
                    :error="errors[0]"
                    type="radio"
                    name="custom"
                    v-model="userGender"
                    :options="gender"
                  />
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="Phone Number"
                    :error="errors[0]"
                    type="number"
                    v-model="details.mobile_no"
                  />
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }">
                  <Input
                    class="mb-base"
                    label="CNIC"
                    :error="errors[0]"
                    type="number"
                    v-model="details.cnic"
                  />
                </validation-provider>
                <validation-provider>
                  <Checkbox
                    class="mt-3"
                    type="checkbox"
                    name="systemUser"
                    id="systemUser"
                    @input="handleIsSystemUser"
                    :isChecked="false"
                    label="Is System User"
                  />
                </validation-provider>
                <validation-provider>
                  <Radio
                    class="mb-base"
                    className="flex-3"
                    outerLabel="Is other"
                    type="radio"
                    v-model="isOther"
                    :options="organizationType"
                    styles="invoice-type"
                  />
                </validation-provider>
              </div>
              <div class="form-actions">
                <Button
                  className="button--primary custom-button"
                  :onClick="handleNext"
                  title="Next"
                ></Button>
              </div>
            </form>
          </validation-observer>
        </div>
      </template>
    </modal>
    <modal
      title="Create an account"
      name="creatAccount"
      height="auto"
      width="500"
      :adaptive="true"
    >
      <template v-slot:content>
        <div>
          <validation-observer ref="createNewAccount">
            <form class="create-account mb-base">
              <Select
                label="User Role"
                placeholder="Select"
                styles="role-select"
                :input="handelRole"
                :options="listDoctors"
                :clearable="false"
              />
              <Select
                label="Select Branch"
                styles="role-select"
                class="mb-2 mt-2"
                placeholder="Select"
                :input="handleBranchChange"
                :options="brachData"
                :clearable="false"
              />
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  class="mb-base"
                  label="User Name"
                  :error="errors[0]"
                  type="text"
                  v-model="details.user_name"
                />
              </validation-provider>
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  class="mb-base account-input"
                  label="Password"
                  :error="errors[0]"
                  type="password"
                  v-model="details.password"
                />
              </validation-provider>
              <Button
                className="button--primary custom-button"
                :onClick="createAccount"
                :loader="loading"
                title="Create"
              ></Button>
            </form>
          </validation-observer>
        </div>
      </template>
    </modal>
    <modal name="accountCreated" height="400" width="600" :adaptive="true">
      <template v-slot:content>
        <div class="account-created">
          <img src="@/assets/verified.png" alt="verified" />
          <Heading
            className="flex justify-center"
            heading="Account has been created"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Heading from "@/components/Heading";
import DatePicker from "@/components/Datepicker";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import Radio from "@/components/Radio";
import Checkbox from "@/components/Checkbox";
import Button from "@/components/Button";
import Select from "@/components/Select";
import { mapActions, mapGetters } from "vuex";
import { getGender, formatedDate } from "@/utils/helpers";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePicker,
    Heading,
    Button,
    Select,
    Modal,
    Input,
    Checkbox,
    Radio
  },
  data() {
    return {
      showError: "",
      userGender: "",
      brachData: [],
      isOther: "",
      organizationType: [
        { id: "familyhealth", for: "familyhealth", label: "Other" },
        { id: "medirad", for: "medirad", label: "Radiology" }
      ],
      gender: [
        { id: "male", for: "male", label: "Male" },
        { id: "female", for: "female", label: "Female" }
      ],
      details: {}
    };
  },
  methods: {
    ...mapActions({
      addEmployee: "user/addEmployee",
      doctorList: "doctors/doctorList",
      fetchBranch: "expenses/fetchBranch"
    }),
    ageYear(val) {
      this.details.dob = formatedDate(val);
    },
    handleNext() {
      this.details.gender = getGender(this.userGender);
      this.details.isOther = this.isOther == "FHH" ? 1 : 0;
      this.$refs.observer.validate().then(success => {
        if (!success) {
          return;
        }
        if (this.details.isSystemUser == true && this.isOther !== "") {
          this.$modal.show("creatAccount");
        } else if (
          !this.details.isSystemUser ||
          !this.details.isSystemUser == false
        ) {
          this.details = {};
          this.$modal.hide("userInformations");
          this.$toasted
            .show("Account hasn't been created, you are not a system user")
            .goAway("3000");
        } else if (this.isOther == "") {
          this.$toasted.error("Please Check all input feilds").goAway("3000");
        }
      });
    },
    handelRole(val) {
      this.details.role_name = val.name.toLowerCase();
    },
    createAccount() {
      this.$refs.createNewAccount.validate().then(success => {
        if (!success) {
          return;
        }
        if (this.details.role_name && this.details.branchId) {
          this.addEmployee(this.details)
            .then(() => {
              this.$modal.hide("creatAccount");
              this.$modal.hide("userInformations");
              this.$modal.show("accountCreated");
              setTimeout(() => {
                this.$modal.hide("accountCreated");
              }, 2000);
              this.details = {};
            })
            .catch(() => {
              this.$modal.hide("creatAccount");
              this.$modal.hide("userInformations");
              this.$toasted
                .error("Something went wrong, Please try again later")
                .goAway("3000");
            });
        } else if (!this.details.role_name) {
          this.$toasted.error("Please select role for the user").goAway("3000");
        } else if (!this.details.branchId) {
          this.$toasted.error("Please select user branch").goAway("3000");
        }
      });
    },
    handleBranchChange(val) {
      if (val && val !== null) {
        this.details.branchId = val.key;
      }
    },
    handleIsSystemUser(val) {
      if (val && val !== null) {
        this.details.isSystemUser = val;
      }
    }
  },
  computed: {
    ...mapGetters({
      accountCreated: "user/accountCreated",
      listDoctors: "doctors/listDoctors",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      loading: "loading"
    })
  },
  async mounted() {
    await this.fetchBranch();
    this.doctorList("roles");
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
  }
};
</script>

<style scoped>
.account-created {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}
.add-users .form-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--line);
}
.add-users .form-wrapper > span,
.datepicker-wrapper {
  flex: 0 0 30%;
  max-width: 30%;
}
.form-actions {
  display: flex !important;
  justify-content: flex-end !important;
}
.form-actions .form-button {
  margin-right: 3rem;
}
.custom-button {
  padding: 11px 38px;
}
.account-heading {
  border-bottom: 1px solid var(--line);
}
.account-heading h3 {
  margin-bottom: 20px !important;
  font-weight: 600 !important;
  font-size: var(--fs-display) !important;
  color: var(--ink-900);
  letter-spacing: var(--tracking-tight);
}
</style>
